import { renderApp } from "@app"

import { installCorporateChartTheme } from "./Theme/charts"
import AppTest from "./App"


installCorporateChartTheme()

renderApp(AppTest, {
    useServiceWorker: process?.env?.NODE_ENV === 'production'
})